// ── Socket event names ─────────────────────────────────────────────────────
export const SOCKET_EVENTS = {
    // Task events
    TASK_CREATED: 'task:created',
    TASK_UPDATED: 'task:updated',
    TASK_STATUS_CHANGED: 'task:status_changed',
    TASK_DELETED: 'task:deleted',
    // Many tasks or the project's statuses changed at once (a status list was
    // saved or reset, or a status edited or deleted): refetch the whole board.
    TASKS_CHANGED: 'tasks:changed',
    // List events
    // A list or its items changed. Sent to the sockets watching that list.
    LIST_CHANGED: 'list:changed',
    // Some list in an organization was created, changed, shared or deleted, or
    // one was shared with this user. Carries no ids: the lists overview just
    // refetches, through the API's permission checks.
    LISTS_CHANGED: 'lists:changed',
    // Project events
    PROJECT_UPDATED: 'project:updated',
    PROJECT_MEMBER_ADDED: 'project:member_added',
    PROJECT_MEMBER_REMOVED: 'project:member_removed',
    // Presence
    PRESENCE_JOINED: 'presence:joined',
    PRESENCE_LEFT: 'presence:left',
    PRESENCE_HEARTBEAT: 'presence:heartbeat',
    // Room management
    JOIN_PROJECT: 'join:project',
    LEAVE_PROJECT: 'leave:project',
    // Task events for pages spanning many projects (calendar, feedback queue,
    // lists), without showing the user as viewing them. Carries the full set
    // to watch; it replaces the previous one.
    WATCH_PROJECTS: 'watch:projects',
    // The lists a page shows (one, on a list's own page). Replaces the
    // previous set.
    WATCH_LISTS: 'watch:lists',
    // The organization whose lists overview this tab shows, or null.
    WATCH_ORGANIZATION: 'watch:organization',
};
//# sourceMappingURL=socket.js.map